import React from 'react';
import { cn, isProductURLAbsolute } from '@express-labs/raven-tools';
import Link from '../../../../Link/Link';
import s from './ProductCardTitle.scss';
import NavLink from '../../../../NavLink/NavLink';

export interface ProductTitle {
  canUseRouter?: boolean;
  className?: string;
  colorName?: string;
  containerClassName?: string;
  name?: string;
  onCardClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  productId: string;
  productLinkTitle?: string;
  productURL?: string;
  sizeName?: string;
}

interface ProductTitleGutsProps {
  name: string;
  colorName?: string;
  sizeName?: string;
}

const ProductTitleGuts = ({
  name,
  colorName,
  sizeName,
}: ProductTitleGutsProps) => (
  <>
    {name?.trim()}
    <span className="srOnly">
      {colorName && `color ${colorName} `}
      {sizeName && `size ${sizeName} `}.
    </span>
  </>
);

const ProductTitle: React.FC<ProductTitle> = ({
  className,
  colorName,
  containerClassName,
  name,
  onCardClick,
  productId,
  productLinkTitle,
  productURL,
  canUseRouter = true,
  sizeName,
}) => {
  if (!name) {
    return null;
  }

  if (!productURL) {
    return <div className={cn(s.productName, className)}>{name?.trim()}</div>;
  }

  const isAbsoluteURL = isProductURLAbsolute(productURL, productId);

  let to = '';
  let href = '';

  if (canUseRouter && !isAbsoluteURL) {
    to = productURL;
  } else {
    href = productURL;
  }

  return (
    <div className={containerClassName}>
      {href !== '' && (
        <Link
          href={href}
          className={cn(s.productCardTitle, className)}
          data-product-id={productId}
          onClick={onCardClick}
          role="button"
          title={productLinkTitle || `${name} Express View`}
        >
          <ProductTitleGuts
            name={name}
            colorName={colorName}
            sizeName={sizeName}
          />
        </Link>
      )}
      {to !== '' && (
        <NavLink
          className={cn(s.productCardTitle, className)}
          data-product-id={productId}
          onClick={onCardClick}
          role="button"
          title={productLinkTitle || `${name} Express View`}
          to={to}
        >
          <ProductTitleGuts
            name={name}
            colorName={colorName}
            sizeName={sizeName}
          />
        </NavLink>
      )}
    </div>
  );
};

export default ProductTitle;
